import { searchResidents } from '../../../../services/case-plan-create.service';
import { useDebouncedPeopleSearch } from '../../useDebouncedPeopleSearch';

/**
 * Debounced resident search for the Create Plan resident autocomplete.
 */
export const useResidentSearchHook = () =>
  useDebouncedPeopleSearch(searchResidents);
